import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import ActionTypes from '../../../../constants/ActionTypes';
import ApiUrls from '../../../../constants/ApiUrls';
import MiddlewareEntities from '../../../../constants/MiddlewareEntities';
import { RECENTLY_SELECTED_GREENVOUCHER_VALUE } from '../../../../constants/SessionStorageKeys';
import { formatAndDividePrice } from '../../../../utilites/util';
import { apiRequest } from '../../api/actions';
import { clearNotifications, createErrorNotification } from '../../notification/actions';
import { requestFetchManhattanOrderAction } from '../manhattan/transition/actions';
import { setMsisdnRequired, setVoucherCode, setVoucherApplied, setVoucherApplicationFailed } from './actions';

const sendVoucherMiddleware: Middleware = (_: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.ORDER.VOUCHER.SEND_FOR_VERIFICATION:
    const submitData =
      action.payload.msisdn !== ''
        ? { voucher: action.payload.voucher, msisdn: action.payload.msisdn }
        : { voucher: action.payload.voucher };
    next(
      apiRequest(
        null,
        'POST',
        ApiUrls.APPLY_VOUCHER,
        null,
        submitData,
        MiddlewareEntities.ORDER.SEND_VOUCHER_FOR_VERIFICATION,
        { 'captcha-value': action.payload.recaptcha }
      )
    );
    next(setVoucherCode(action.payload.code));
    next(clearNotifications());
    break;
  case `${MiddlewareEntities.ORDER.SEND_VOUCHER_FOR_VERIFICATION} ${ActionTypes.API_SUCCESS}`:
    next(requestFetchManhattanOrderAction({}));
    next(setMsisdnRequired(false));
    break;

  case `${MiddlewareEntities.ORDER.SEND_VOUCHER_FOR_VERIFICATION} ${ActionTypes.API_ERROR}`:
    // when 424 show msisdn input
    if (action.payload.data.status === 424) {
      next(setMsisdnRequired(true));
    } else {
      next(createErrorNotification(action.payload.data, MiddlewareEntities.ORDER.MANHATTAN.ORDER));
    }
    break;

  case ActionTypes.ORDER.GREEN_VOUCHER.SEND_FOR_VERIFICATION:
    next(
      apiRequest(
        null,
        'POST',
        ApiUrls.VERIFICATION_GREEN_VOUCHER,
        null,
        {
          voucher: action.payload.voucher,
        },
        MiddlewareEntities.ORDER.GREEN_VOUCHER.SEND_VOUCHER_FOR_VERIFICATION,
        { 'captcha-value': action.payload.recaptcha }
      )
    );
    next(setVoucherCode(action.payload.code));
    next(clearNotifications());
    break;
  case `${MiddlewareEntities.ORDER.GREEN_VOUCHER.SEND_VOUCHER_FOR_VERIFICATION} ${ActionTypes.API_SUCCESS}`:
    const { voucherSerialNumber, voucherValue, dateCreated } = action.payload.data.data;
    const voucherDate = new Date(dateCreated.split('T')[0]).toLocaleDateString('sr-RS');

    sessionStorage.setItem(RECENTLY_SELECTED_GREENVOUCHER_VALUE, (voucherValue * 100).toString());

    next(
      setVoucherApplied({
        voucherSerialNumber,
        voucherValue: formatAndDividePrice(voucherValue * 100) as string,
        voucherDate,
      })
    );
    break;
  case `${MiddlewareEntities.ORDER.GREEN_VOUCHER.SEND_VOUCHER_FOR_VERIFICATION} ${ActionTypes.API_ERROR}`:
    const { message } = action.payload.data.session.flashMessages[0];
    next(setVoucherApplicationFailed(message));
    break;
  }
};

export const voucherMiddleware = [sendVoucherMiddleware];
